import Vue from 'vue';
import FloatingPanel from 'components/widgets/FloatingPanel/FloatingPanel.vue';
import ToolTipPanel from 'components/widgets/ToolTipPanel/ToolTipPanel.vue';
import ChartToolTipBody from 'components/widgets/ChartToolTipBody/ChartToolTipBody.vue';
export default Vue.extend({
    components: { FloatingPanel, ToolTipPanel, ChartToolTipBody },
    props: {
        container: { type: Element, default: null },
        x: { type: Number, default: 0 },
        y: { type: Number, default: 0 },
        visible: { type: Boolean, default: true }
    },
    computed: {
        // returns `container` if provided, otherwise the parentNode of this component
        containerEl() {
            if (this.container) {
                return this.container;
            }
            return this.$el ? this.$el.parentNode : undefined;
        }
    }
});
